import { render, staticRenderFns } from "./InsurableValue.vue?vue&type=template&id=3dedf98d&scoped=true&"
import script from "./InsurableValue.vue?vue&type=script&lang=js&"
export * from "./InsurableValue.vue?vue&type=script&lang=js&"
import style0 from "./InsurableValue.vue?vue&type=style&index=0&id=3dedf98d&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dedf98d",
  null
  
)

export default component.exports